// full library entry point.

"use strict";
module.exports = require("./src/index");
module.exports.util.isNode = true;

require('./ext/descriptor');
